export const PROMOCODE_MODAL_NAME = 'promocode-modal';
